module.exports = __webpack_public_path__ + "img/swarm of servants.11a1432a.png";